
    <ezs-dashboard 
      [user]="authenticatedUser$ | async"
      [account]="account$ | async"
      [reports]="reports$ | async"
      [features]="features$ | async"
      (init)="onComponentInit()">
    </ezs-dashboard>
  